import { IPagination } from "src/app/shared/models/page.model";
import { ICompanyFilter, ICompanyFilterState, ICountry, ICurrency, ICustomer, ILocation, IPayment_term, IState } from "../models/customers.models";
import { Action, createReducer, on } from "@ngrx/store";
import * as customersActions from "./customers.actions"
import { refillCompanyFilter } from "src/app/shared/utils/helpers";



export interface CustomersState {
  metadata: IPagination | null;
  customer: ICustomer | null;
  customers: ICustomer[];
  allCustomers: ICustomer[];
  allLocations: ILocation[];
  locations: ILocation[];
  allPaymentTerms: IPayment_term[];
  allCountries: ICountry[];
  allStates: IState[];
  allCurrencies: ICurrency[];
  loading: boolean;
  companyLoading: boolean;
  statesLoading: boolean;
  countriesLoading: boolean;
  paymentTermsLoading: boolean;
  currenciesLoading: boolean;
  companyFilterState: ICompanyFilterState;
}

export const initialProductsState: CustomersState = {
  metadata: null,
  customer: null,
  customers: [],
  allCustomers: [],
  allPaymentTerms: [],
  allLocations: [],
  locations: [],
  allCountries: [],
  allStates: [],
  allCurrencies: [],
  loading: false,
  companyLoading: false,
  statesLoading: false,
  countriesLoading: false,
  paymentTermsLoading: false,
  currenciesLoading: false,
  companyFilterState: {
    advanced: refillCompanyFilter(),
    keyword: ''
  }
}

const featureReducer = createReducer(
  initialProductsState,
  on(
    customersActions.FetchAllCustomersSuccess,
    (state, action) => ({
      ...state,
      allCustomers: action.customers.data,
    })
  ),
  on(
    customersActions.FetchLocationsSuccess,
    (state, action) => ({
      ...state,
      locations: action.locations.data,
      metadata: action.locations.metadata
    })
  ),
  on(
    customersActions.FetchAllLocationsSuccess,
    (state, action) => ({
      ...state,
      allLocations: action.locations.data,
    })
  ),
  on(
    customersActions.FetchAllpaymentTermsSuccess,
    (state, action) => ({
      ...state,
      allPaymentTerms: action.paymentTerms.data,
    })
  ),
  on(
    customersActions.FetchAllCountriesSuccess,
    (state, action) => ({
      ...state,
      allCountries: action.countries.data,
    })
  ),
  on(
    customersActions.FetchAllStatesSuccess,
    (state, action) => ({
      ...state,
      allStates: action.states.data,
    })
  ),
  on(
    customersActions.FetchAllCurrenciesSuccess,
    (state, action) => ({
      ...state,
      allCurrencies: action.currencies.data,
    })
  ),
  on(
    customersActions.FetchCustomersSuccess,
    (state, action) => ({
      ...state,
      customers: action.customers.data,
      metadata: action.customers.metadata
    })
  ),
  on(customersActions.AddCustomerSuccess, (state, action) => ({
    ...state,
    allCustomers: [...state.allCustomers, action.customer as ICustomer],
  })),
  on(customersActions.SetCustomersLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(customersActions.SetCompanyLoader, (state, action) => ({
    ...state,
    companyLoading: action.isLoading
  })),
  on(customersActions.SetCountryLoader, (state, action) => ({
    ...state,
    countriesLoading: action.isLoading
  })),
  on(customersActions.SetStatesLoader, (state, action) => ({
    ...state,
    statesLoading: action.isLoading
  })),
  on(customersActions.SetPaymentTermsLoader, (state, action) => ({
    ...state,
    paymentTermsLoading: action.isLoading
  })),
  on(customersActions.SetCurrenciesLoader, (state, action) => ({
    ...state,
    currenciesLoading: action.isLoading
  })),
  on(customersActions.SetCompanyFilter, (state, action) => {
    return {
    ...state,
    companyFilterState: {
      ...state.companyFilterState,
      keyword: action.keyword,
      advanced: action.advanced!
    }
  }
}),
  on(customersActions.SetCompanySearch, (state, action) => ({
    ...state,
    companyFilterState: {
      ...state.companyFilterState,
      keyword: action.keyword
    }
  })),
  on(customersActions.exportCompanies, (state) => ({
    ...state,
    loading: true,
  })),
  on(customersActions.exportCompaniesSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(customersActions.GetCompanyByIdSuccess, (state, action) => ({
    ...state,
    customer: action.company,
    loading: false,
  })),
  on(customersActions.CustomerApprobationSuccess, (state, action)=>({
    ...state,
    customer: action.customer,
    loading: false
  })),
  on(customersActions.UpdateLocationSuccess, (state, action) => ({
    ...state,
    allLocations: state.allLocations.map(l =>
      l.id === action.location.id ? { ...l, ...action.location } : l
    ),
    locations: state.locations.map(l =>
      l.id === action.location.id ? { ...l, ...action.location } : l
    ),
  })),
  on(customersActions.DeleteLocationContactSuccess, (state, { locationId, contactId }) => {
    const removeContact = (l: ILocation) =>
      l.id === locationId
        ? { ...l, contacts_information: (l.contacts_information ?? []).filter(c => c.id !== contactId) }
        : l;
    return {
      ...state,
      allLocations: state.allLocations.map(removeContact),
      locations: state.locations.map(removeContact),
    };
  })
)



export function customersReducer(state: CustomersState | undefined, action: Action) {
  return featureReducer(state, action);
}
